import { render, staticRenderFns } from "./BasicTimepicker.vue?vue&type=template&id=422c2adf"
import script from "./BasicTimepicker.vue?vue&type=script&lang=js"
export * from "./BasicTimepicker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports